export const fr = {
  appName: "Horaires de Prière",
  tabs: {
    prayer: "Prière",
    qiblah: "Qibla",
    masjid: "Mosquée",
    settings: "Paramètres",
    more: "Plus"
  },
  prayer: {
    nextPrayer: "Prochaine Prière",
    locating: "Détermination de votre position...",
    now: "Maintenant",
    fajr: "Fajr",
    sunrise: "Lever du Soleil",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    loading: "Chargement…",
    nextPrayerIn: "Prochaine prière:",
    in: "dans",
    today: "Aujourd'hui"
  },
  qiblah: {
    title: "Détecteur de Qibla",
    subtitle: "Tournez l'appareil pour aligner les marqueurs",
    compass: "Boussole",
    direction: "Direction",
    gettingLocation: "Obtention de la localisation…",
    locationPermissionRequired: "L'autorisation de localisation est requise.",
    refresh: "Actualiser"
  },
  masjid: {
    title: "Trouver une Mosquée",
    placeholder: "Rechercher une adresse ou une ville...",
    searching: "Recherche sur Google Maps...",
    viewOnMaps: "Voir sur Google Maps",
    noResults: "Aucun résultat trouvé à proximité.",
    local: "Local",
    search: "Rechercher"
  },
  settings: {
    title: "Paramètres",
    location: "Localisation",
    manual: "Localisation Manuelle",
    cityCountry: "Rechercher ville...",
    latitude: "Latitude",
    longitude: "Longitude",
    calc: "Calcul",
    calcMethod: "Méthode de Calcul",
    asrMethod: "Méthode Asr",
    appearance: "Apparence",
    lang: "Langue",
    theme: "Thème",
    system: "Système",
    light: "Clair",
    dark: "Sombre",
    save: "Enregistrer",
    adhanEnabled: "Activer l'Adhan",
    persistentNotifications: "Notifications Persistantes",
    ishaTime: "Heure Isha",
    fajrTime: "Heure Fajr",
    ishaDefault: "Par défaut",
    fajrDefault: "Par défaut",
    minAfterMaghrib: "Minutes après Maghrib",
    minBeforeSunrise: "Minutes avant le Lever du Soleil",
    fixedTime: "Heure Fixe",
    prayers: "Prières",
    muslimWorldLeague: "Ligue Mondiale Musulmane",
    standard: "Standard"
  },
  more: {
    back: "Retour",
    tasbih: "Tasbih",
    reset: "Réinitialiser",
    count: "Compter",
    hijri: "Calendrier Hijri",
    now: "Maintenant",
    highlights: "Points Forts du Mois",
    events: "Événements et Actualités",
    ramadan: "DÉBUT DU RAMADAN",
    eid: "EID AL-ADHA",
    duas: "Duas Quotidiennes",
    kahf: "Sourate Al-Kahf",
    listenFull: "ÉCOUTER LA SOURATE COMPLÈTE",
    pause: "PAUSE",
    stats: "Statistiques de Prière",
    statsDesc: "Intervalles de temps entre les fenêtres de prière quotidiennes",
    fajrToMaghrib: "Fajr à Maghrib",
    dhuhrToAsr: "Dhuhr à Asr",
    sunriseToSunset: "Lever à Coucher du Soleil",
    fajrToSunrise: "Fajr au Lever du Soleil",
    maghribToIsha: "Maghrib à Isha",
    appInfo: "Informations sur l'App",
    zakat: "Calculatrice de Zakat",
    zakatDesc: "Calculez votre Zakat (2.5% de la richesse)",
    zakatTotal: "ZAKAT DUE",
    cashSavings: "Espèces / Épargne",
    goldValue: "Valeur de l'Or",
    silverValue: "Valeur de l'Argent",
    nisabNote: "Assurez-vous que votre richesse atteint le seuil de Nisab avant de payer la Zakat",
    inheritance: "Calculatrice d'Héritage",
    inheritanceDesc: "Calculez la distribution de l'héritage islamique",
    estateValue: "Valeur du Patrimoine",
    selectHeirs: "Sélectionner les Héritiers",
    heirHusband: "Mari",
    heirWife: "Épouse",
    heirFather: "Père",
    heirMother: "Mère",
    heirSon: "Fils",
    heirDaughter: "Fille",
    distribution: "DISTRIBUTION",
    share: "part",
    disclaimer: "Ceci est un calcul simplifié. Consultez un érudit pour les cas complexes.",
    namesOfAllah: "99 Noms d'Allah",
    nameNumber: "NOM #",
    spiritualBenefit: "Bénéfice Spirituel",
    weekDays: ["D", "L", "M", "M", "J", "V", "S"],
    monthly: "Horaires Mensuels",
    halalPlaces: "Lieux Halal",
    trains: "Trains",
    less: "Moins",
    more: "Plus...",
    downloadApp: "Télécharger l'App Mobile",
    adjustHijri: "Ajuster la Date Hijri",
    hijriCycle: "Cycle Hijri",
    year: "Année",
    thisYear: "Cette Année",
    tenYearOverview: "Aperçu de 10 Ans",
    ayahs: "Ayahs",
    ayah: "AYAH",
    fetchingAyahs: "Récupération des Ayahs...",
    morning: "Matin",
    evening: "Soir",
    prayerStatistics: "Statistiques de Prière",
    prayerIntervals: "Intervalles de temps de prière",
    daylightHours: "Heures de lumière du jour",
    afternoonPeriod: "Période de l'après-midi",
    fullDaylight: "Lumière du jour complète",
    dawnPeriod: "Période de l'aube",
    eveningPeriod: "Période du soir",
    errorLoading: "Erreur de chargement des statistiques",
    loadingStats: "Chargement des statistiques...",
    sons: "Fils",
    daughters: "Filles",
    searchHalal: "Rechercher des lieux halal",
    searching: "Recherche...",
    noResults: "Aucun résultat trouvé",
    viewOnMaps: "Voir sur Cartes",
    selectStation: "Sélectionner la Gare",
    favorites: "Favoris",
    useCurrentLocation: "Utiliser la Position Actuelle",
    refresh: "Actualiser",
    loading: "Chargement...",
    dataSource: "Données de Liikennevirasto Digital API. Sous licence Creative Commons Attribution 4.0",
    appVersion: "Version",
    appDescription: "Horaires de prière et utilitaires islamiques pour la Finlande"
  },
  trains: {
    useCurrentLocation: "Ma Position",
    selectStation: "Sélectionner la Gare",
    noTrainsFound: "Aucun train trouvé",
    time: "Heure",
    track: "Voie",
    train: "Train",
    destination: "Destination",
    cancelled: "Annulé"
  },
  ramadan: {
    title: "Ramadan 2026",
    expected: "Attendu:",
    date: "18-19 fév",
    daysLeft: "jours restants",
    today: "Aujourd'hui!",
    fastingHours: "Heures de Jeûne"
  }
};
